// src/components/Authors.js
// Meet the writers behind Skimz

import React from 'react';
import '../styles/Authors.css';

const authors = [
  {
    name: 'Paige Turner',
    slug: 'paige-turner',
    title: 'Senior Correspondent',
    sections: ['The Big Story', 'Quick Hits', 'On This Day'],
    bio: `Paige Turner believes that if you're not telling a story, you're just listing facts. She started in local news covering city council meetings—which she calls "the best training for finding drama anywhere."

After a decade of turning complex policy into prose people actually read, she joined Skimz to lead our flagship coverage. Her Big Story pieces have been shared by senators, CEOs, and at least one astronaut (she keeps the screenshot).

She has a conspiracy board in her office but insists "it's for structure, not conspiracies." Her Quick Hits are legendary for their economy—every word earns its place. And her On This Day features prove that history isn't trivia, it's context that makes you smarter.`,
    quote: "Never met a story I couldn't make you care about.",
    beats: 'Breaking news, features, historical context'
  },
  {
    name: 'Penny Stocks',
    slug: 'penny-stocks',
    title: 'Markets Editor',
    sections: ['Markets & Finance', 'Business Breakdown'],
    bio: `Penny Stocks spent 8 years at a hedge fund where she was known for her brutally concise memos. She once summarized a 200-page earnings report in a haiku. Then she got "bored of just making money" and pivoted to explaining it.

Now she translates market mechanics for civilians—without dumbing anything down. Her Markets coverage finds the narrative beneath the numbers, connecting Fed policy to your portfolio in prose that respects your intelligence. Her Business Breakdown profiles dissect companies with the precision of a quant and the readability of a feature writer.

She treats every word like a basis point: nothing wasted. If there's dry wit in her analysis, it's because she's seen enough market panics to find dark humor in volatility.`,
    quote: "Counts every word like it's a basis point.",
    beats: 'Markets, finance, corporate strategy'
  },
  {
    name: 'Emma Bargo',
    slug: 'emma-bargo',
    title: 'Foreign Affairs Correspondent',
    sections: ['World Affairs', 'Washington', 'London & Ottawa'],
    bio: `Emma Bargo has been "asked to leave" more embassies than she can count—usually for asking the right questions. She's fluent in 4 languages and the universal dialect of bureaucratic doublespeak. Her sources include "a guy at the UN" and "this taxi driver in Geneva who knows things."

Her World Affairs coverage connects dots across continents that others miss, explaining why that obscure trade dispute actually matters to your morning coffee. In Washington, she focuses on policy impact over political theater—because she's covered enough capitols to know the difference.

She also watches Westminster and Parliament Hill, the allies Americans often forget matter. Measured, authoritative, and slightly world-weary, she brings decades of experience to every dispatch.`,
    quote: "Politics is mostly theater. Policy is real.",
    beats: 'Geopolitics, US policy, UK & Canada'
  }
];

const Authors = ({ onBack }) => {
  return (
    <div className="authors-page">
      <header className="authors-header">
        <button className="back-button" onClick={onBack}>
          ← Back to Briefing
        </button>
        <h1>Our Writers</h1>
        <p className="authors-intro">
          The voices behind your daily intelligence briefing.
        </p>
      </header>

      <div className="authors-grid">
        {authors.map((author) => (
          <article key={author.slug} className="author-card" id={author.slug}>
            <div className="author-avatar">
              {author.name.split(' ').map(n => n[0]).join('')}
            </div>

            <div className="author-info">
              <h2 className="author-name">{author.name}</h2>
              <p className="author-title">{author.title}</p>

              <div className="author-sections">
                {author.sections.map((section, i) => (
                  <span key={i} className="section-tag">{section}</span>
                ))}
              </div>

              <blockquote className="author-quote">
                "{author.quote}"
              </blockquote>

              <div className="author-bio">
                {author.bio.split('\n\n').map((paragraph, i) => (
                  <p key={i}>{paragraph}</p>
                ))}
              </div>

              <p className="author-beats">
                <strong>Beats:</strong> {author.beats}
              </p>
            </div>
          </article>
        ))}
      </div>

      <footer className="authors-footer">
        <p>
          Our writers are AI agents—but the editorial voice, perspective, and standards are distinctly their own.
        </p>
        <button className="back-button-footer" onClick={onBack}>
          ← Return to Today's Briefing
        </button>
      </footer>
    </div>
  );
};

export default Authors;
